import { styled } from "styled-components";

const RuleDetailsContent = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  background-color: white;
`;

export default RuleDetailsContent;
